"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(restoreEditor),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(setEditorInitialized),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(preloadData),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(cancelAll),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(baseSaga);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = baseSaga;

var _effects = require("redux-saga/effects");

var _core = require("@widget-editor/core");

var _constants = require("@widget-editor/map/lib/constants");

var _actions = require("@widget-editor/shared/lib/modules/configuration/actions");

var _actions2 = require("@widget-editor/shared/lib/modules/editor/actions");

var _actions3 = require("@widget-editor/shared/lib/modules/widget-config/actions");

var _actions4 = require("@widget-editor/shared/lib/modules/filters/actions");

var _exposedHooks = require("../../exposed-hooks");

function restoreEditor() {
  return regeneratorRuntime.wrap(function restoreEditor$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)((0, _actions2.resetEditor)());

        case 2:
          _context.next = 4;
          return (0, _effects.put)((0, _actions.resetConfiguration)());

        case 4:
          _context.next = 6;
          return (0, _effects.put)((0, _actions3.resetWidgetConfig)());

        case 6:
          _context.next = 8;
          return (0, _effects.put)((0, _actions4.resetFilters)());

        case 8:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function setEditorInitialized() {
  return regeneratorRuntime.wrap(function setEditorInitialized$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.put)((0, _actions2.setEditor)({
            initialized: true
          }));

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

function preloadData() {
  var _ref, _ref$widgetEditor, editor, storeConfiguration, _relevantMetadata$att, _relevantMetadata$att2, _editor$dataset, _editor$dataset$attri, _editor$widget, _editor$widget$attrib, _editor$widget$attrib2, _editor$widget$attrib3, _widgetConfig$paramsC, _widgetConfig$paramsC2, _editor$widget$attrib4, name, metadata, description, widgetConfig, mapSpecifics, relevantMetadata, caption, datasetType, rasterOnly, isMap, paramsConfig, configuration, format;

  return regeneratorRuntime.wrap(function preloadData$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.select)();

        case 2:
          _ref = _context3.sent;
          _ref$widgetEditor = _ref.widgetEditor;
          editor = _ref$widgetEditor.editor;
          storeConfiguration = _ref$widgetEditor.configuration;

          if (!editor.widget) {
            _context3.next = 28;
            break;
          }

          _editor$widget$attrib4 = editor.widget.attributes, name = _editor$widget$attrib4.name, metadata = _editor$widget$attrib4.metadata, description = _editor$widget$attrib4.description, widgetConfig = _editor$widget$attrib4.widgetConfig;
          mapSpecifics = _objectSpread({}, storeConfiguration.map, {}, widgetConfig.hasOwnProperty("lat") ? {
            lat: widgetConfig.lat
          } : {}, {}, widgetConfig.hasOwnProperty("lng") ? {
            lat: widgetConfig.lng
          } : {}, {}, widgetConfig.hasOwnProperty("bbox") ? {
            bbox: widgetConfig.bbox
          } : {}, {}, widgetConfig.hasOwnProperty("basemapLayers") ? {
            basemap: {
              basemap: Object.keys(_constants.BASEMAPS).indexOf(widgetConfig.basemapLayers.basemap) !== -1 ? widgetConfig.basemapLayers.basemap : "dark",
              labels: Object.keys(_constants.LABELS).indexOf(widgetConfig.basemapLayers.labels) !== -1 ? widgetConfig.basemapLayers.labels : "none",
              boundaries: typeof widgetConfig.basemapLayers.boundaries === 'boolean' ? widgetConfig.basemapLayers.boundaries : false
            }
          } : {
            basemap: {
              basemap: "dark",
              labels: "none",
              boundaries: false
            }
          }, {}, widgetConfig.hasOwnProperty("zoom") ? {
            zoom: widgetConfig.zoom
          } : {});
          relevantMetadata = metadata === null || metadata === void 0 ? void 0 : metadata[0];
          caption = (_relevantMetadata$att = relevantMetadata === null || relevantMetadata === void 0 ? void 0 : (_relevantMetadata$att2 = relevantMetadata.attributes.info) === null || _relevantMetadata$att2 === void 0 ? void 0 : _relevantMetadata$att2.caption) !== null && _relevantMetadata$att !== void 0 ? _relevantMetadata$att : '';
          datasetType = editor === null || editor === void 0 ? void 0 : (_editor$dataset = editor.dataset) === null || _editor$dataset === void 0 ? void 0 : (_editor$dataset$attri = _editor$dataset.attributes) === null || _editor$dataset$attri === void 0 ? void 0 : _editor$dataset$attri.type;
          rasterOnly = !!(datasetType && datasetType.match(/raster/));
          isMap = rasterOnly || (editor === null || editor === void 0 ? void 0 : (_editor$widget = editor.widget) === null || _editor$widget === void 0 ? void 0 : (_editor$widget$attrib = _editor$widget.attributes) === null || _editor$widget$attrib === void 0 ? void 0 : (_editor$widget$attrib2 = _editor$widget$attrib.widgetConfig) === null || _editor$widget$attrib2 === void 0 ? void 0 : (_editor$widget$attrib3 = _editor$widget$attrib2.paramsConfig) === null || _editor$widget$attrib3 === void 0 ? void 0 : _editor$widget$attrib3.visualizationType) === "map";
          paramsConfig = widgetConfig.hasOwnProperty("paramsConfig") ? widgetConfig.paramsConfig : null;

          if ((paramsConfig === null || paramsConfig === void 0 ? void 0 : paramsConfig.aggregateFunction) === 'none') {
            paramsConfig.aggregateFunction = null;
          }

          configuration = _objectSpread({}, paramsConfig ? _objectSpread({}, paramsConfig) : {}, {
            title: name,
            description: description,
            caption: caption,
            rasterOnly: rasterOnly,
            visualizationType: isMap ? "map" : "chart"
          }, isMap ? {
            chartType: "map"
          } : {}, {
            map: mapSpecifics
          });
          format = (widgetConfig === null || widgetConfig === void 0 ? void 0 : (_widgetConfig$paramsC = widgetConfig.paramsConfig) === null || _widgetConfig$paramsC === void 0 ? void 0 : (_widgetConfig$paramsC2 = _widgetConfig$paramsC.value) === null || _widgetConfig$paramsC2 === void 0 ? void 0 : _widgetConfig$paramsC2.format) || "s";

          if (!configuration.orderBy) {
            _context3.next = 21;
            break;
          }

          _context3.next = 21;
          return (0, _effects.put)((0, _actions4.setFilters)(_objectSpread({}, configuration.orderBy ? {
            orderBy: configuration.orderBy
          } : {})));

        case 21:
          if (paramsConfig) {
            _context3.next = 26;
            break;
          }

          _context3.next = 24;
          return (0, _effects.put)((0, _actions2.setEditor)({
            advanced: true
          }));

        case 24:
          _context3.next = 26;
          return (0, _effects.put)((0, _actions3.setWidgetConfig)(widgetConfig));

        case 26:
          _context3.next = 28;
          return (0, _effects.put)((0, _actions.setConfiguration)(_objectSpread({}, configuration, {
            format: format
          })));

        case 28:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}

function cancelAll() {
  var _ref2, adapter, tasks;

  return regeneratorRuntime.wrap(function cancelAll$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _ref2 = (0, _exposedHooks.getLocalCache)(), adapter = _ref2.adapter;
          adapter.abortRequests();
          _context4.next = 4;
          return (0, _effects.all)([(0, _effects.fork)(preloadData), (0, _effects.fork)(setEditorInitialized)]);

        case 4:
          tasks = _context4.sent;
          _context4.next = 7;
          return (0, _effects.cancel)(_toConsumableArray(tasks));

        case 7:
          _context4.next = 9;
          return (0, _effects.call)(restoreEditor);

        case 9:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}

function baseSaga() {
  return regeneratorRuntime.wrap(function baseSaga$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.takeLatest)(_core.constants.sagaEvents.DATA_FLOW_DATASET_WIDGET_READY, preloadData);

        case 2:
          _context5.next = 4;
          return (0, _effects.takeLatest)(_core.constants.sagaEvents.DATA_FLOW_RESTORE, restoreEditor);

        case 4:
          _context5.next = 6;
          return (0, _effects.takeLatest)(_core.constants.sagaEvents.DATA_FLOW_VISUALIZATION_READY, setEditorInitialized);

        case 6:
          _context5.next = 8;
          return (0, _effects.takeLatest)(_core.constants.sagaEvents.DATA_FLOW_UNMOUNT, cancelAll);

        case 8:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}